/**
 * Пример использования:
 *
 <cat-calendar
 id="calendar-{{../id}}{{@index}}"
 cat-datepicker-id="{{../id}}"
 cat-type="{{type}}"
 cat-afrom="{{../availableRange.from}}"
 cat-atill="{{../availableRange.till}}"
 cat-rfrom="{{../range.from}}"
 cat-rtill="{{../range.till}}"
 cat-selected-date="{{../selectedDate}}"
 cat-select-date="{{../selectDateSignal}}"
 cat-date="{{date}}"
 class="{{../css.calendar}}">
 </cat-calendar>
 *
 * {{id}}
 * id календаря
 *
 * {{availableRange}}
 * период доступный для выбора в дейтпикере
 *
 * {{type}}
 * Тип отображения календаря (месяцы/годы)
 *
 * {{range}}
 * выбранный период в дейтпикере
 *
 * {{selectedDate}}
 * текущая выбранная дата в календаре (при варианте когда нельзя выбрать период)
 *
 * {{selectDateSignal}}
 * сигнал когда была выбрана одна дата в календаре
 *
 * {{date}}
 * начальная дата месяца/года календаря
 */
let css = require('./calendar.css');
let _ = require('lodash');
let moment = require('moment');
let $ = require('jquery');

const ITEM = `.${css.item}`;
const IS_DISABLED = `.${css._isDisabled}`;

class Calendar {
    constructor () {
        this.template = require('./template');
    }

    bind () {
        return {
            click: {
                [ITEM]: this.selectDate
            }
        };
    }

    selectDate (e) {
        let item = $(e.currentTarget).children();
        let date = item.attr('cat-date');

        if (!item.hasClass(IS_DISABLED.substring(1))) {
            let selectDate = this.$context.props['selectDate'];
            let datepickerId = this.$context.attributes['cat-datepicker-id'];
          
            this.$context.signal(selectDate, { date, datepickerId });
        }
    }

    /**
     * Формирует массив массивов с внутренней размерностью n
     * @param  {Array} array исходный массив
     * @param  {Number} n размерность на которую необходимо разбивать исходный массива
     * @return {Array} результирующий массив
     */
    static reshape (array, n) {
        return _.compact(_.map(array, (el, i) => {
            if (i % n === 0) {
                return array.slice(i, i + n);
            }
        }));
    }

    static equalsForBounds (date, range, period) {
        let bounds = range.toDate();
        let start = moment(bounds[0]);
        let end = moment(bounds[1]);

        return date.isSame(start, period) ||
            date.isSame(end, period);
    }

    render () {
        let attrs = this.$context.attributes;

        this.type = attrs['cat-type'];
        this.date = Number(attrs['cat-date']);

        const typesMap = {
            month: this.getFormatedMonth,
            year: this.getFormatedYear
        };

        let calendarTypeFunc = typesMap[this.type] || this.getFormatedMonth;
        let availableRange = this.getAvailableRange();
        let selectedRange = this.getSelectedRange();

        let data = calendarTypeFunc(this.date, availableRange, selectedRange);

        return Object.assign({}, data, { css });
    }

    /**
     * Получение доступного периода
     * @return {Object}
     */
    getAvailableRange () {
        let attrs = this.$context.attributes;

        if (attrs['cat-afrom'] || attrs['cat-atill']) {
            let from = moment.unix(Number(attrs['cat-afrom']));
            let tillUnix = attrs['cat-atill'];
            let till = tillUnix ? moment.unix(Number(tillUnix)) : from.clone().add(1, 'years');

            return moment.range(from, till);
        }

        return {};
    }

    /**
     * Получение выбранного периода
     * @return {Object}
     */
    getSelectedRange () {
        let attrs = this.$context.attributes;
        let selectedDate = Number(attrs['cat-selected-date']);
        let rangeDates;

        if (selectedDate) {
            rangeDates = {
                from: moment.unix(selectedDate),
                till: moment.unix(selectedDate)
            };
        } else {
            rangeDates = {
                from: moment.unix(Number(attrs['cat-rfrom'])),
                till: moment.unix(Number(attrs['cat-rtill']))
            };
        }

        return moment.range(rangeDates.from, rangeDates.till);
    }

    /**
     * Получение даты в формате годов
     * @param {Object} date - начальная дата календаря
     * @param {Object} availableRange - доступный период дат
     * @param {Object} range - выбранный период
     * @return {Object}
     */
    getFormatedYear (date, availableRange, range) {
        let yearContent = [];

        let currentDate = moment.unix(date).startOf('year');

        _.times(12, () => {
            let unixDate = currentDate.unix();
            let inSelectdedRange = range.contains(currentDate);
            let inAvailableRange = availableRange.contains(currentDate);

            let isBoundOfRange = Calendar.equalsForBounds(currentDate, range, 'month');

            yearContent.push({
                date: _.capitalize(currentDate.format('MMM')),
                isInRange: inSelectdedRange,
                isBoundOfRange,
                isDisabled: !inAvailableRange,
                unixDate
            });

            currentDate.add(1, 'months');
        });

        yearContent = Calendar.reshape(yearContent, 3);

        let periodTitle = moment.unix(date).format('YYYY');
        let mode = 'year';

        return {
            periodTitle,
            content: yearContent,
            mode
        };
    }

    /**
     * Получение даты в формате годов
     * @param {Object} date - начальная дата календаря
     * @param {Object} availableRange - доступный период дат
     * @param {Object} range - выбранный период
     * @return {Object}
     */
    getFormatedMonth (date, availableRange, range) {
        /**
         * Количество дней в месяце определенного года
         * @param  {Object} momentDate moment.js Объект
         * @return {Number} результат
         */
        function daysInMonth (momentDate) {
            return momentDate.toDate().getDate();
        }

        const daysLabels = moment.weekdaysShort();
        daysLabels.push(daysLabels.shift());

        let monthStart = moment.unix(date).startOf('month');
        let monthEnd = moment.unix(date).endOf('month');

        let numOfDays = daysInMonth(monthEnd);
        let startOffset = monthStart.day() - 1;

        if (startOffset == -1) {
            startOffset = 6;
        }
        let endOffset = 42 - (numOfDays + startOffset);

        let monthContent = [];

        _.times(startOffset, () => {
            monthContent.push({ isHidden: true });
        });

        let currentDate = monthStart;

        _.times(numOfDays, (i) => {
            let unixDate = currentDate.unix();

            let inAvailableRange = availableRange.contains(currentDate);
            let inSelectedRange = range.contains(currentDate);

            let isBoundOfRange = Calendar.equalsForBounds(currentDate, range, 'day');

            monthContent.push({
                date: i + 1,
                isDisabled: !inAvailableRange,
                isInRange: inSelectedRange,
                isBoundOfRange,
                unixDate
            });

            currentDate.add(1, 'days');
        });

        _.times(endOffset, () => {
            monthContent.push({ isHidden: true });
        });

        monthContent = Calendar.reshape(monthContent, 7);

        let periodTitle = moment.unix(date).format('MMMM YYYY');
        let mode = 'month';

        return {
            periodTitle,
            content: monthContent,
            daysLabels,
            mode
        };
    }
}

module.exports = {
    constructor: Calendar
};



// WEBPACK FOOTER //
// ./packages/account-ui/calendar/index.js